import React from 'react'
import './package.css';
import { price } from '../data/Data';
import Button from '@mui/material/Button';
function Packages() {
    return (
        <section className="paddings flexDisplay package-section">
            <h1 className='primaryText'>Select Your Package</h1>
            <p className='secondaryText'>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                <br />praesentium voluptatum deleniti atque corrupti quos dolores
            </p>
            <div className="containerPackage">
                {price.map((item, index) => (
                    <div className='onlyPackage' key={index}>
                        <h2 className='xl:text-2xl text-xl capitalize font-bold'>{item.plan}</h2>
                        <h1 className='xl:text-4xl text-2xl capitalize font-bold'>${item.price}</h1>
                        <p className='secondaryText'>{item.ptext}</p>
                        <div className="flex justify-start items-start flex-col gap-8">
                            <span className='font-semibold xl:text-lg text-sm'>{item.list[0].icon} {item.list[0].text}</span>
                            <span className='font-semibold xl:text-lg text-sm'>{item.list[1].icon} {item.list[1].text}</span>
                            <span className='font-semibold xl:text-lg text-sm'>{item.list[2].icon} {item.list[2].text}</span>
                            <span className='font-semibold xl:text-lg text-sm'>{item.list[3].icon} {item.list[3].text}</span>
                            <span className='font-semibold xl:text-lg text-sm'>{item.list[4].icon} {item.list[4].text}</span>
                        </div>
                        <Button variant="contained" className={item.button==="Start Standard"?"Standard":"nother"}>{item.button}</Button>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Packages
